export async function assetExists(url: string): Promise<boolean> {
  try {
    const res = await fetch(url, { method: "GET", headers: { Range: "bytes=0-32" } });
    if (!res.ok) return false;
    const type = res.headers.get("content-type") ?? "";
    if (type.includes("text/html") || type.includes("text/css") || type.includes("javascript")) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export const modelGlbUrl = "/assets/models/m1908/m1908.glb";
